<div class="timeline-shell card">
  <div class="card-body">
    <div class="timeline-toolbar">
      <div class="timeline-title-wrap">
        <h6 class="timeline-title mb-0">Timeline</h6>
        <small class="text-muted">{{ totalCount }} updates</small>
      </div>

      <div class="timeline-filters">
        @for (f of filterSummary; track f.key) {
          <button
            type="button"
            class="filter-chip"
            [class.active]="activeFilter === f.key"
            (click)="selectFilter(f.key)">
            <span>{{ f.label }}</span>
            <span class="count">{{ f.count }}</span>
          </button>
        }
      </div>
    </div>

    @if (isLoading) {
      <div class="timeline-loading">
        @for (p of [1, 2, 3, 4]; track p) {
          <div class="timeline-skeleton-item">
            <div class="dot"></div>
            <div class="content">
              <div class="line w60"></div>
              <div class="line w90"></div>
              <div class="line w40"></div>
            </div>
          </div>
        }
      </div>
    } @else if (hasData && filteredTimelineItems.length) {
      <div class="timeline-list">
        @for (item of filteredTimelineItems; track trackById($index, item)) {
          <article class="timeline-item" [ngClass]="item.typeClass">
            <div class="timeline-rail">
              <span class="timeline-dot">
                <i [class]="item.icon"></i>
              </span>
            </div>

            <div class="timeline-content">
              <div class="timeline-meta">
                <span class="event-type">{{ item.title }}</span>
                <span class="event-relative">{{ item.relativeDate }}</span>
              </div>

              <div class="event-body">{{ getBodyPreview(item) }}</div>

              @if (item.type === 'File' && item.canPreview) {
                <button type="button" class="expand-link preview-link" (click)="previewFile(item)">
                  Preview
                </button>
              }

              @if (item.isLong) {
                <button type="button" class="expand-link" (click)="toggleExpand(item)">
                  {{ item.isExpanded ? 'Show less' : 'Read more' }}
                </button>
              }

              <div class="timeline-foot">
                <span class="event-author">{{ item.author }}</span>
                <span class="event-date">{{ item.displayDate }}</span>
              </div>
            </div>
          </article>
        }
      </div>
    } @else {
      <div class="timeline-empty">
        <i class="e-icons e-warning"></i>
        <p class="mb-0">No {{ activeFilter === 'All' ? '' : activeFilter.toLowerCase() + ' ' }}records found.</p>
      </div>
    }
  </div>
</div>

<app-image-preview
  [(visible)]="previewImageVisible"
  [title]="previewTitle"
  [imageUrl]="previewImageUrl"
  (closed)="closePreview()">
</app-image-preview>

<app-pdf-preview
  [(visible)]="previewPdfVisible"
  [title]="previewTitle"
  [pdfBytes]="previewPdfBytes"
  (closed)="onPdfPreviewClosed()">
</app-pdf-preview>
